import { Address, isAddressEqual } from 'viem';

export * from './team';
export * from './social-links';
export * from './launchpads';
export * from './ecosystem-links';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const isZeroAddress = (address: string | Address) => isAddressEqual(address as Address, ZERO_ADDRESS);
